import React, { useEffect } from 'react';
import { Create as EditIcon } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import Text from '../../../components/Typography/Text';
import Table, {
  columnType,
  tempFilteredRows,
} from '../../../components/ClearingTable/Table';
import { list } from '../../../services/AchWireRequestService';
import Button from '../../../components/Buttons/Button';
import AutoCompleteAccountNo from '../../../components/AutoComplete/AutoCompleteAccountNo';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteMasterAccountNo from '../../../components/AutoComplete/AutoCompleteMasterAccountNo';
import ManualInputModal from '../BankAccount/Component/ManualInputModal';
import AchWireRequestModal from './Component/AchWireRequestModal';
import SelectSystemCode from '../../../components/Dropdown/SelectSystemCode';
import TextField from '../../../components/Textfields/TextField';
import DateTimePicker from '../../../components/Textfields/DateTimePicker';
import MoneyField from '../../../components/Textfields/MoneyField';
import { getSystemDate } from '../../../services/ProfileService';
import {
  notifyError,
  notifyInfo,
  notifyWarning,
} from '../../../components/Messages/Notification';
import QueryParam from '../../../services/QueryParamService';
import { getCurrentUser, getAccess } from '../../../services/AuthService';
import {
  getAccountInfo,
  getAccessibleClient,
} from '../../../services/ClientAccountService';
import { CreateLinkToken } from '../../../services/PlaidService';
import Checkbox from '../../../components/Misc/Checkbox';

import {
  CustomBodyRenderCurrencyLeft,
  CustomBodyRenderBoolean,
  CustomBodyRenderAlign,
} from '../../../components/Table/CustomBodyRender';
import { formatPbDate } from '../../../lib/fmt';
import { protoTimeSpanObjectToString } from '../../../services/ConvertService';
import { formatCurrencySymbol } from '../../../lib/fmt2';

export default function AchWireRequest() {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState({
    search: false,
    save: false,
  });

  const [lockTable, setLockTable] = React.useState(true);
  const [defaultAccount, setDefaultAccount] = React.useState([]);
  const [pagination, setPagination] = React.useState({});
  const [totalRows, setTotalRows] = React.useState(0);
  const [footerData, setFooterData] = React.useState({});
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [openAddBank, setOpenAddBank] = React.useState(false);
  const [isOpen, setOpen] = React.useState(false);
  const [rowData, setRowData] = React.useState({});
  const [modalData, setModalData] = React.useState({});

  const [addBankData] = React.useState({
    correspondent: '',
    accountNo: '',
    bankOwnerName: '',
    bankName: '',
    achRoutingNo: '',
    wireRoutingNo: '',
    bankAccountNo: '',
    bankAddress: '',
    bankAccountType: '',
    approvedMethod: '',
    plaidAccessToken: '',
    status: 'Pending Approval',
    bankIdentifierCode: '',
    isInternational: false,
  });
  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      fromDate: '',
      toDate: '',
      correspondent: '',
      accountNo: '',
      externalId: '',
      masterAccountNo: '',
      transferType: '',
      requestType: '',
      status: '',
      sign: '',
      amount: '',
      isOpen: false,
      dateType: 'System Date',
    })
  );

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  const init = async () => {
    let account_no = '';
    let correspondent = '';
    try {
      const systemDate = await getSystemDate();

      const loggeduser = getCurrentUser();

      if (loggeduser.AccountId !== 0) {
        const account = await getAccountInfo();

        setDefaultAccount(account);
        account_no = account.accountNo;
        correspondent = account.correspondent;
      } else {
        const account = await getAccessibleClient(loggeduser.UserId);
        setDefaultAccount(account);
        account_no = account.client.accountNo;
        correspondent = account.client.correspondent;
      }
      if (!getAccess('account_no', loggeduser.UserType)) {
        setSearchData({
          ...searchData,
          fromDate: searchData.fromDate ? searchData.fromDate : systemDate,
          toDate: searchData.toDate ? searchData.toDate : systemDate,
          accountNo: account_no,
          correspondent: correspondent,
        });
      } else {
        setSearchData({
          ...searchData,
          fromDate: searchData.fromDate ? searchData.fromDate : systemDate,
          toDate: searchData.toDate ? searchData.toDate : systemDate,
        });
      }
    } catch (error) {
      notifyError(error.message);
    }
  };

  const handleOpen = (data) => {
    if (!data) {
      //ADD default values
      const correspondent = defaultAccount?.client?.correspondent
        ? defaultAccount.client.correspondent
        : '';
      const account_no = defaultAccount?.client?.accountNo
        ? defaultAccount.client.accountNo
        : '';
      data = {
        correspondent: correspondent,
        accountNo: account_no,
        bankId: '',
        amt: '',
        transferType: '',
        requestType: '',
        status: 'Pending',
        fee: '0',
        bankNote: '',
        bank: '',
        // sendTo: 'BMO',
      };
    } else {
      data.action = 'edit';
    }

    setRowData(data);
    setOpen(true);
  };

  const handleClose = async (data, isEdit) => {
    // if close is clicked, close the modal
    if (!data) {
      setOpen(false);
      return;
    }

    // If add bank is clicked
    if (data.isAddBank) {
      // re-initialize isAddBank
      data.isAddBank = false;

      const loggeduser = getCurrentUser();
      var linkToken;

      if (loggeduser === null) return;
      try {
        const lt = await CreateLinkToken({
          name: 'SAS',
          country: 'US',
          id: loggeduser.UserId,
          type: 'Micro Deposit',
        });
        if (lt.errorCode !== '') {
          notifyError(lt.errorCode + ' ' + lt.errorMessage);
          console.error(lt);
          return;
        }
        linkToken = lt;
      } catch (e) {
        notifyError(e);
        console.error(e);
        return;
      }
      addBankData.linktoken = linkToken;

      //backup the modal data
      setModalData(data);

      //close modal
      setOpen(false);

      //set initial value of correspondent and account no
      addBankData.correspondent = data.correspondent;
      addBankData.accountNo = data.accountNo;

      // open the add bank modal
      setOpenAddBank(true);
      // If save is clicked, save the ACH/Wire entry
    } else {
      try {
        if (isEdit) {
          //EDIT
          const rowsCopy = [...rows];
          const index = rows.indexOf(rowData);
          rowsCopy[index] = data;
          // setRows(rowsCopy);
          fetchData();
        } else {
          //ADD
          // setRows([data, ...rows]);
          fetchData();
        }
        setOpen(false);
      } catch (error) {
        notifyError(error.message);
      }
    }
  };

  const handleSearchDataChange = (e, checkboxValue) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    if (input.name === 'sign' && input.value === '') {
      searchData.amount = '';
    }

    setSearchData({
      ...searchData,
      [input.name]:
        checkboxValue === true || checkboxValue === false ? checkboxValue : input.value,
    });
  };

  const fetchData = async () => {
    try {
      QueryParam.set(searchData);
      const { requestsList } = await list(searchData);

      let rowsCopy = requestsList;

      const rowsCopyOutput = rowsCopy.map((data) => {
        data.createdAt = data.createdAt
          ? protoTimeSpanObjectToString(data.createdAt, 'MM/DD/YYYY hh:mm:ss a')
          : '--';
        data.modifiedAt = data.modifiedAt
          ? protoTimeSpanObjectToString(data.modifiedAt, 'MM/DD/YYYY hh:mm:ss a')
          : '--';

        let tempDate2 = formatPbDate(data.systemDate);
        data.systemDate = tempDate2;

        return data;
      });

      setRows(rowsCopyOutput);
    } catch (error) {
      notifyError(error.message);
      return;
    }
  };

  const getCsvData = async () => {
    if (lockTable === true) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };
    const { requestsList } = await list(searchDataCsv, paginationCopy);

    const rowsCopy = requestsList.map((item) => {
      item.createdAt = item.createdAt
        ? protoTimeSpanObjectToString(item.createdAt, 'MM/DD/YYYY hh:mm:ss a')
        : '--';
      item.modifiedAt = item.modifiedAt
        ? protoTimeSpanObjectToString(item.modifiedAt, 'MM/DD/YYYY hh:mm:ss a')
        : '--';

      let tempDate2 = formatPbDate(item.systemDate);
      item.systemDate = tempDate2;

      let tempDate3 = formatPbDate(item.processDate);
      item.processDate = tempDate3;

      return item;
    });

    return rowsCopy;
  };

  const handleSearch = async (paginationChange) => {
    let valid = true;

    if (!searchData.isOpen) {
      if (!searchData.fromDate) {
        notifyWarning('From Date is required.');
        valid = false;
      }

      if (!searchData.toDate) {
        notifyWarning('To Date is required.');
        valid = false;
      }
    }

    if (!valid) {
      return;
    }

    try {
      setLoading({ ...loading, search: true });
      if (paginationChange !== true) {
        setLockTable(false);
      }
      if (paginationChange === true) {
        if (lockTable === true) {
          return;
        }
      }

      QueryParam.set(searchData);
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };

      const data = await list(searchData, paginationCopy);
      setSearchDataCsv(searchData);
      setTotalRows(data.summary.totalRows);

      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      let rowsCopy = data.requestsList;

      const rowsCopyOutput = rowsCopy.map((item) => {
        item.createdAt = item.createdAt
          ? protoTimeSpanObjectToString(item.createdAt, 'MM/DD/YYYY hh:mm:ss a')
          : '--';
        item.modifiedAt = item.modifiedAt
          ? protoTimeSpanObjectToString(item.modifiedAt, 'MM/DD/YYYY hh:mm:ss a')
          : '--';

        let tempDate2 = formatPbDate(item.systemDate);
        item.systemDate = tempDate2;

        tempDate2 = formatPbDate(item.processDate);
        item.processDate = tempDate2;

        return item;
      });

      setRows(rowsCopyOutput);

      if (paginationChange !== true) {
        notifyInfo(data.summary.totalRows + ' search results.');
      }

      setFooterData({
        amt: formatCurrencySymbol(data.summary.amt),
        fee: formatCurrencySymbol(data.summary.fee),
      });
    } catch (error) {
      notifyError(error.message);
      return;
    } finally {
      setLoading({ ...loading, search: false });
    }
  };

  const handleCloseAddBank = async (data) => {
    console.log('Data: ' + data);
    // if close, is clicked
    if (!data) {
      setOpenAddBank(false);
      setRowData(modalData);
      setOpen(true);
      return;
    }

    try {
      setOpenAddBank(false);
      const copyModalData = {
        ...modalData,
        accountNo: data.status === 'Active' ? data.accountNo : modalData.accountNo,
        bankId: data.status === 'Active' ? data.bankId : modalData.bankId,
        correspondent:
          data.status === 'Active' ? data.correspondent : modalData.correspondent,
        bank: data.status === 'Active' ? data.bankName : modalData.bank,
        isInternational:
          data.status === 'Active' ? data.isInternational : modalData.isInternational,
      };
      setRowData(copyModalData);
      setOpen(true);
    } catch (error) {
      notifyError(error.message);
    }
  };

  const columns = [
    {
      name: 'actions',
      label: 'Actions',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {tempFilteredRows[dataIndex]?.bankAddressId !== 0 && (
                <IconButton onClick={() => handleOpen(tempFilteredRows[dataIndex])}>
                  <EditIcon style={{ height: 25, width: 25 }} />
                </IconButton>
              )}
            </div>
          );
        },
        sort: false,
      },
    },
    {
      name: 'requestId',
      label: 'Request ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      // Already converted to string in handlesearch
      name: 'systemDate',
      label: 'System Date',
    },
    {
      // Already converted to string in handlesearch
      name: 'processDate',
      label: 'Process Date',
      options: {
        display: false,
      },
    },
    {
      name: 'accountId',
      label: 'Account ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'branch',
      label: 'Branch',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'accountNo',
      label: 'Account No',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'rep',
      label: 'Rep',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'bankId',
      label: 'Bank ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'walletId',
      label: 'Wallet ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      name: 'bankAccountNo',
      label: 'Bank Account No',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'bankRoutingNo',
      label: 'Bank Routing No',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'bankName',
      label: 'Bank Name',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'requestType',
      label: 'Request Type',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'transferType',
      label: 'Transfer Type',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'amt',
      label: 'Amount',
      options: {
        customBodyRender: CustomBodyRenderCurrencyLeft,
      },
      addFooter: true,
      type: columnType.amount,
    },
    {
      name: 'fee',
      label: 'Fee',
      options: {
        customBodyRender: CustomBodyRenderCurrencyLeft,
      },
      addFooter: true,
      type: columnType.amount,
    },
    {
      name: 'fedNo',
      label: 'Fed No',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'externalId',
      label: 'External ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        visible: false,
      },
    },
    {
      name: 'bank',
      label: 'Bank',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'bankNote',
      label: 'Bank Note',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'createdBy',
      label: 'Created By',
      options: {
        display: false,
      },
    },
    {
      // Already converted to string in handlesearch
      name: 'createdAt',
      label: 'Created At',
    },
    {
      // Already converted to string in handlesearch
      name: 'modifiedAt',
      label: 'Modified At',
    },
    {
      name: 'modifiedBy',
      label: 'Modified By',
      options: {
        display: false,
      },
    },
    {
      name: 'isInternational',
      label: 'Is International',
      options: {
        customBodyRender: CustomBodyRenderBoolean,
      },
      type: columnType.bool,
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
    serverSide: true,
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="ACH\Wire Request" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading.search}
              loading={loading.search}
              type="search"
              label={loading.search ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading.save}
              loading={loading.save}
              type="plus"
              label="Add ACH\Wire Request"
              onClick={() => handleOpen()}
            />
          </div>
        </div>

        <div>
          <div className="grd-row">
            <div className="grd-cell">
              <SelectSystemCode
                name="dateType"
                label="Date Type"
                type="Date Type ACH"
                value={searchData.dateType}
                onChange={handleSearchDataChange}
                disableBlank
              ></SelectSystemCode>
            </div>
            <div className="grd-cell">
              <DateTimePicker
                disabled={searchData.isOpen}
                type="date"
                name="fromDate"
                label="From Date"
                value={searchData.fromDate}
                onChange={handleSearchDataChange}
                required={true}
                inputProps={{ max: searchData.toDate }}
              />
            </div>
            <div className="grd-cell">
              <DateTimePicker
                disabled={searchData.isOpen}
                type="date"
                name="toDate"
                label="To Date"
                value={searchData.toDate}
                onChange={handleSearchDataChange}
                required={true}
                inputProps={{ min: searchData.fromDate }}
              />
            </div>
            <div className="grd-cell">
              <AutoCompleteCorrespondent
                name="correspondent"
                value={searchData.correspondent}
                onChange={handleSearchDataChange}
              />
            </div>
            <div className="grd-cell">
              <AutoCompleteAccountNo
                name="accountNo"
                value={searchData.accountNo}
                correspondent={searchData.correspondent}
                onChange={handleSearchDataChange}
              />
            </div>
            <div className="grd-cell">
              <TextField
                name="externalId"
                label="External ID"
                placeholder="External ID"
                type="text"
                value={searchData.externalId}
                onChange={handleSearchDataChange}
              />
            </div>
          </div>
          <div className="grd-row">
            <div className="grd-cell">
              <AutoCompleteMasterAccountNo
                name="masterAccountNo"
                value={searchData.masterAccountNo}
                correspondent={searchData.correspondent}
                onChange={handleSearchDataChange}
              />
            </div>
            <div className="grd-cell">
              <SelectSystemCode
                name="transferType"
                label="Transfer Type"
                placeholder="Transfer Type"
                type="Type"
                subType="Transfer Type"
                value={searchData.transferType}
                onChange={handleSearchDataChange}
              />
            </div>
            <div className="grd-cell">
              <SelectSystemCode
                name="status"
                label="Status"
                placeholder="Status"
                type="Status"
                subType="Bank Request"
                value={searchData.status}
                onChange={handleSearchDataChange}
              />
            </div>
            <div className="grd-cell">
              <div className="grd-row nm">
                <div className="grd-cell">
                  <SelectSystemCode
                    name="sign"
                    label="Sign"
                    placeholder="Sign"
                    type="Sign"
                    subType="Bank Request"
                    value={searchData.sign}
                    onChange={handleSearchDataChange}
                  />
                </div>
                <div className="grd-cell">
                  <MoneyField
                    disabled={searchData.sign ? false : true}
                    name="amount"
                    label="Amount"
                    placeholder="$"
                    value={searchData.amount}
                    onChange={handleSearchDataChange}
                  />
                </div>
              </div>
            </div>
            <div className="grd-cell">
              <Checkbox
                mt={40}
                name="isOpen"
                label="Open"
                checked={searchData.isOpen}
                onChange={handleSearchDataChange}
              />
            </div>
            <div className="grd-cell"></div>
          </div>
        </div>
      </div>

      <div className="mt-20">
        <Table
          title={'ACH\\Wire Request'}
          data={rows}
          columns={columns}
          options={options}
          getCsvData={getCsvData}
          pagination={pagination}
          setPagination={setPagination}
          onSearch={handleSearch}
          footerData={footerData}
        />
      </div>

      {isOpen && (
        <AchWireRequestModal
          onClose={handleClose}
          open={isOpen}
          value={rowData}
        ></AchWireRequestModal>
      )}
      {openAddBank && (
        <ManualInputModal
          onClose={handleCloseAddBank}
          iopen={openAddBank}
          value={addBankData}
        ></ManualInputModal>
      )}
    </form>
  );
}
